import { useInstance } from '@meraki-internal/react-dependency-injection';
import { CareMapState } from '../caremap/CareMapState';
import { HistoryViewModel } from '../support/HistoryViewModel';

export const useSwitchCareMap = () => {
    const history = useInstance(HistoryViewModel);
    const careMapState = useInstance(CareMapState);

    return async (careMapId: string) => {
        // swap care map in state
        const previousCaremapId = careMapState.getMostRecentCaremap()!.careMapId;
        await careMapState.setActiveCaremap(careMapId);

        // if caremapid in the route or querystring, swap it
        const currentPath = history.getCurrentLocation().pathname;
        const params = history.getCurrentSearchParamMap();
        if (currentPath.includes(previousCaremapId) || params.id === previousCaremapId) {
            const newPath = currentPath.replace(previousCaremapId, careMapId);
            history.push(newPath);
        }
    };
};
